import { Pipe, PipeTransform } from '@angular/core';
import { GamificationProvider } from '../providers/gamification';

@Pipe({
  name: 'userHistoryPoints'
})

export class UserHistoryPointsPipe implements PipeTransform {

  constructor(
    private gamificationProvider: GamificationProvider
  ) { }

  transform(value: string, clientId: string): any {
    return this.gamificationProvider.getHistoryUserPoints(value, clientId).map(points => {
      return points.reverse();
    });
  }
}


// WEBPACK FOOTER //
// ./src/pipes/userHistoryPoints.pipe.ts